import Title from '@/components/Title';
export default {
  components: {
    Title
  },
  props: {
    casesText: String,
    source: String,
    showCase: {
      type: Boolean,
      default: false
    },
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    paddingStyle() {
      const style = {
        paddingTop: '70px'
      };
      if (this.showCase) {
        style.paddingTop = '24px';
      }
      return style;
    },
    caseStyle() {
      const style = {
        height: '650px'
      };
      if (this.source === 'shortsPlatform') {
        style.height = '430px';
      } else if (this.source === 'healthcare') {
        style.height = '400px';
      } else {
        console.log('height');
      }
      return style;
    },
    bgStyle() {
      let bgUrl;
      if (this.source === 'shortsPlatform') {
        bgUrl = require('@/assets/images/components/shortsPlatform-broker-list.png');
      } else if (this.source === 'healthcare') {
        bgUrl = require('@/assets/images/components/healthcareSolutions-broker-list.png');
      } else if (this.source === 'aiProduct') {
        bgUrl = require('@/assets/images/components/cooperative-partner.png');
      } else {
        bgUrl = require('@/assets/images/components/case-broker-list.png');
      }
      const style = {
        height: '273px',
        background: `url(${bgUrl}) center no-repeat`,
        backgroundSize: 'contain'
      };
      if (this.source === 'shortsPlatform') {
        style.height = '84px';
        style.background = `url(${bgUrl}) center no-repeat`;
        style.backgroundSize = 'contain';
      } else if (this.source === 'healthcare') {
        style.height = '140px';
        style.background = `url(${bgUrl}) center no-repeat`;
        style.backgroundSize = 'contain';
      }
      return style;
    },
    textStyle() {
      const style = {
        marginTop: '20px',
        color: 'rgba(0,0,0,0.45)'
      };
      if (this.source === 'shortsPlatform' || this.source === 'healthcare') {
        style.marginTop = '40px';
        style.color = 'rgba(0,0,0,0.85)';
      }
      return style;
    },
    caseTitle() {
      let title = 'Cases';
      if (this.source === 'mobileTerminal') {
        title = 'Why Choose Mobile Financial Terminal';
      } else if (this.source === 'pcTerminal') {
        title = 'Why Choose PC Finanicial Terminal';
      } else if (this.source === 'shortsPlatform') {
        title = '为什么选择短视频平台';
      } else if (this.source === 'healthcare') {
        title = '为什么选择医疗保健解决方案';
      }
      return title;
    },
    brokerStyle() {
      const style = {
        height: 'auto',
        padding: '50px 0 24px'
      };
      if (this.source === 'shortsPlatform') {
        style.height = 'auto';
        style.padding = '20px';
      } else if (this.source === 'healthcare') {
        style.height = 'auto';
        style.padding = '10px 20px 15px 20px';
      } else if (this.source === 'aiProduct') {
        style.height = 'auto';
        style.padding = '30px 0 44px';
      }
      return style;
    }
  }
};